"use client";

import { useEffect } from "react";

import { usePathname } from "@/i18n/navigation";
import { getSmoothScroller } from "@/lib/smooth-scroll";

const scrollToCurrentHash = () => {
  const hash = window.location.hash;
  if (!hash) {
    return;
  }

  const target = document.getElementById(decodeURIComponent(hash.slice(1)));
  if (!target) {
    return;
  }

  // With a smooth scroller the browser has already jumped to the hash. Sync the
  // scroller to that spot at once, or it scrolls the page back to where it was.
  const smoothScroller = getSmoothScroller();
  if (smoothScroller) {
    const scrollMargin = parseFloat(getComputedStyle(target).scrollMarginTop);
    smoothScroller.scrollTo(target, {
      offset: -(scrollMargin || 0),
      immediate: true,
    });
    return;
  }

  const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ? "auto"
    : "smooth";
  target.scrollIntoView({ behavior, block: "start" });
};

export const ScrollToHash = () => {
  const pathname = usePathname();

  useEffect(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(scrollToCurrentHash);
    });
  }, [pathname]);

  useEffect(() => {
    const onHashChange = () => scrollToCurrentHash();
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  return null;
};
